export const POTENTIAL_HEADING = {
  image:
    "https://appthing-website.s3.ap-south-1.amazonaws.com/choose-img-1.png",
  companyTitle: "Best Creative IT Agency And Solutions",
  companySince: "Since 2018.",
  description:
    "From strategy to execution, we craft intelligent IT solutions designed to help you innovate faster and stay ahead of the competition.",
  topRight:
    "https://appthing-website.s3.ap-south-1.amazonaws.com/choose-vec-top-r.svg",
  bottomLeft:
    "https://appthing-website.s3.ap-south-1.amazonaws.com/choose-vec-btm-l.svg",
};

export const POTENTIAL_DATA = [
  {
    id: 1,
    value: 90,
    suffix: "%",
    title: "Strategy",
    description:
      "We craft result-driven strategies that align with your business goals and market opportunities.",
  },
  {
    id: 2,
    value: 99,
    suffix: "%",
    title: "Audience",
    description:
      "Our solutions focus on understanding your audience to deliver personalized and impactful experiences.",
  },
  {
    id: 3,
    value: 95,
    suffix: "%",
    title: "Keyword",
    description:
      "Optimized keyword research ensures better visibility, higher engagement, and stronger online presence.",
  },
];
